import React from "react";
import Jumbotron from "../components/Jumbotron";
import AboutMe from "../components/About";

function About() {
    return (
        <>
        <Jumbotron />
        <AboutMe />
        </>
    )
}

export default About;